import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';

const FaqItem = ({ item, index, isOpen, onToggle }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    setHeight(isOpen ? contentRef.current.scrollHeight : 0);
  }, [isOpen]);

  const num = String(index + 1).padStart(2, '0');

  return (
    <div className={`acc-item ${isOpen ? 'acc-item--open' : ''}`}>
      <button className="acc-trigger acc-trigger--faq" onClick={onToggle} aria-expanded={isOpen}>
        <span className="acc-num">{num}</span>
        <span className="acc-title">{item.question}</span>
        <span className="acc-chevron">{isOpen ? '−' : '+'}</span>
      </button>

      <div className="acc-body" style={{ height: `${height}px` }}>
        <div className="acc-body-inner acc-body-inner--faq" ref={contentRef}>
          {item.answer.map((paragraph, i) => (
            <p key={i} className="acc-answer">{paragraph}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

const FaqAccordion = () => {
  const { t } = useTranslation('faq');
  const faqItems = t('faqItems', { returnObjects: true });
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="accordion__container">
      {faqItems.map((item, index) => (
        <FaqItem
          key={item.id}
          item={item}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
        />
      ))}
    </div>
  );
};

export default FaqAccordion;
